/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ strong: NonNullable<unknown> }} Misc_Posts_Speciallist_Combat1Inputs */

const id_misc_posts_speciallist_combat1 = /** @type {(inputs: Misc_Posts_Speciallist_Combat1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`🎮 ${i?.strong}: Pertarungan lightsaber, baku tembak blaster, dan pertempuran luar angkasa.`)
};

const ms_misc_posts_speciallist_combat1 = /** @type {(inputs: Misc_Posts_Speciallist_Combat1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`🎮 ${i?.strong}: Pertarungan lightsaber, tembakan blaster, dan pertempuran angkasa.`)
};

const da_misc_posts_speciallist_combat1 = /** @type {(inputs: Misc_Posts_Speciallist_Combat1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`🎮 ${i?.strong}: Lyssværdskampe, blaster-skudvekslinger og rumkampe.`)
};

const de_misc_posts_speciallist_combat1 = /** @type {(inputs: Misc_Posts_Speciallist_Combat1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`🎮 ${i?.strong}: Lichtschwertkämpfe, Blastergefechte und Weltraumschlachten.`)
};

const en_us2_misc_posts_speciallist_combat1 = /** @type {(inputs: Misc_Posts_Speciallist_Combat1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`🕹️ ${i?.strong}: Lightsaber battles, blaster shootouts, and space dogfights.`)
};

const es_es2_misc_posts_speciallist_combat1 = /** @type {(inputs: Misc_Posts_Speciallist_Combat1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`🎮 ${i?.strong}: Batallas de sables de luz, tiroteos de bláster y combates espaciales.`)
};

const es_mx2_misc_posts_speciallist_combat1 = /** @type {(inputs: Misc_Posts_Speciallist_Combat1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`🎮 ${i?.strong}: Batallas de sables de luz, tiroteos de blaster y combates espaciales.`)
};

const fil_misc_posts_speciallist_combat1 = /** @type {(inputs: Misc_Posts_Speciallist_Combat1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.strong}: Laban ng lightsaber, shootout ng blaster, at space dogfights.`)
};

const fr_misc_posts_speciallist_combat1 = /** @type {(inputs: Misc_Posts_Speciallist_Combat1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`🕹️ ${i?.strong} : Combats au sabre laser, fusillades au blaster et dogfights spatiaux.`)
};

const it_misc_posts_speciallist_combat1 = /** @type {(inputs: Misc_Posts_Speciallist_Combat1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.strong}: Duelli con spade laser, scontri con blaster e combattimenti spaziali.`)
};

const hu_misc_posts_speciallist_combat1 = /** @type {(inputs: Misc_Posts_Speciallist_Combat1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.strong}: Fénykardpárbajok, blaster lövöldözések és űrcsaták.`)
};

const nl_misc_posts_speciallist_combat1 = /** @type {(inputs: Misc_Posts_Speciallist_Combat1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.strong}: Lightsaber-gevechten, blaster-schietpartijen en ruimtegevechten.`)
};

const no_misc_posts_speciallist_combat1 = /** @type {(inputs: Misc_Posts_Speciallist_Combat1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.strong}: Lysabel-kamper, blaster-skyting og romkamper.`)
};

const pl_misc_posts_speciallist_combat1 = /** @type {(inputs: Misc_Posts_Speciallist_Combat1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`🕹️ ${i?.strong}: Walki na miecze świetlne, strzelaniny z blasterów i kosmiczne potyczki.`)
};

const pt_br2_misc_posts_speciallist_combat1 = /** @type {(inputs: Misc_Posts_Speciallist_Combat1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`🕹️ ${i?.strong}: Batalhas com sabres de luz, tiroteios com blasters e lutas espaciais.`)
};

const pt_misc_posts_speciallist_combat1 = /** @type {(inputs: Misc_Posts_Speciallist_Combat1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`🕹️ ${i?.strong}: Batalhas de sabres de luz, tiroteios com blasters e combates espaciais.`)
};

const ro_misc_posts_speciallist_combat1 = /** @type {(inputs: Misc_Posts_Speciallist_Combat1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`🕹️ ${i?.strong}: Lupte cu săbii laser, împușcături cu blastere și lupte spațiale.`)
};

const fi_misc_posts_speciallist_combat1 = /** @type {(inputs: Misc_Posts_Speciallist_Combat1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`🕹️ ${i?.strong}: Valosapelitaistelut, blasteriampumiset ja avaruusottelut.`)
};

const sv_misc_posts_speciallist_combat1 = /** @type {(inputs: Misc_Posts_Speciallist_Combat1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`🕹️ ${i?.strong}: Ljussvärdsstrider, blaster-skjutningar och rymdstrider.`)
};

const vi_misc_posts_speciallist_combat1 = /** @type {(inputs: Misc_Posts_Speciallist_Combat1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`🕹️ ${i?.strong}: Đấu kiếm ánh sáng, đấu súng blaster và không chiến.`)
};

const tr_misc_posts_speciallist_combat1 = /** @type {(inputs: Misc_Posts_Speciallist_Combat1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`🕹️ ${i?.strong}: Işın kılıcı dövüşleri, blaster çatışmaları ve uzay savaşları.`)
};

const cs_misc_posts_speciallist_combat1 = /** @type {(inputs: Misc_Posts_Speciallist_Combat1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`🕹️ ${i?.strong}: Souboje se světelnými meči, přestřelky s blastery a vesmírné bitvy.`)
};

const bg_misc_posts_speciallist_combat1 = /** @type {(inputs: Misc_Posts_Speciallist_Combat1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`🕹️ ${i?.strong}: Светлинни битки с мечове, бластерни престрелки и космически битки.`)
};

const ru_misc_posts_speciallist_combat1 = /** @type {(inputs: Misc_Posts_Speciallist_Combat1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`🕹️ ${i?.strong}: Битвы на световых мечах, перестрелки из бластеров и космические сражения.`)
};

const uk_misc_posts_speciallist_combat1 = /** @type {(inputs: Misc_Posts_Speciallist_Combat1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`🎮 ${i?.strong}: Битви на світлових мечах, перестрілки з бластерів та космічні бої.`)
};

const ar_misc_posts_speciallist_combat1 = /** @type {(inputs: Misc_Posts_Speciallist_Combat1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`🎮 ${i?.strong}: معارك السيوف الضوئية، واشتباكات البلازما، ومعارك الفضاء.`)
};

const hi_misc_posts_speciallist_combat1 = /** @type {(inputs: Misc_Posts_Speciallist_Combat1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`🎮 ${i?.strong}: गतिशील युद्ध।`)
};

const th_misc_posts_speciallist_combat1 = /** @type {(inputs: Misc_Posts_Speciallist_Combat1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`🎮 ${i?.strong}: การต่อสู้ด้วยไลท์เซเบอร์ การยิงปะทะด้วยบลาสเตอร์ และการต่อสู้ในอวกาศ`)
};

const ja_misc_posts_speciallist_combat1 = /** @type {(inputs: Misc_Posts_Speciallist_Combat1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`🎮 ${i?.strong}：ライトセーバー戦、ブラスター戦、宇宙ドッグファイト。`)
};

const zh_cn2_misc_posts_speciallist_combat1 = /** @type {(inputs: Misc_Posts_Speciallist_Combat1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`🕹️ ${i?.strong}：光剑对决、爆能枪激战和太空狗斗。`)
};

const zh_hant1_misc_posts_speciallist_combat1 = /** @type {(inputs: Misc_Posts_Speciallist_Combat1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`🕹️ ${i?.strong}: 光劍戰鬥、爆能槍槍戰和太空狗鬥。`)
};

const ko_misc_posts_speciallist_combat1 = /** @type {(inputs: Misc_Posts_Speciallist_Combat1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`🕹️ ${i?.strong}: 라이트세이버 전투, 블래스터 총격전, 우주 공중전.`)
};

/**
* | output |
* | --- |
* | "🕹️ {strong}: Lightsaber battles, blaster shootouts, and space dogfights." |
*
* @param {Misc_Posts_Speciallist_Combat1Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const misc_posts_speciallist_combat1 = /** @type {((inputs: Misc_Posts_Speciallist_Combat1Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Misc_Posts_Speciallist_Combat1Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_misc_posts_speciallist_combat1(inputs)
	if (locale === "ms") return ms_misc_posts_speciallist_combat1(inputs)
	if (locale === "da") return da_misc_posts_speciallist_combat1(inputs)
	if (locale === "de") return de_misc_posts_speciallist_combat1(inputs)
	if (locale === "en-US") return en_us2_misc_posts_speciallist_combat1(inputs)
	if (locale === "es-ES") return es_es2_misc_posts_speciallist_combat1(inputs)
	if (locale === "es-MX") return es_mx2_misc_posts_speciallist_combat1(inputs)
	if (locale === "fil") return fil_misc_posts_speciallist_combat1(inputs)
	if (locale === "fr") return fr_misc_posts_speciallist_combat1(inputs)
	if (locale === "it") return it_misc_posts_speciallist_combat1(inputs)
	if (locale === "hu") return hu_misc_posts_speciallist_combat1(inputs)
	if (locale === "nl") return nl_misc_posts_speciallist_combat1(inputs)
	if (locale === "no") return no_misc_posts_speciallist_combat1(inputs)
	if (locale === "pl") return pl_misc_posts_speciallist_combat1(inputs)
	if (locale === "pt-BR") return pt_br2_misc_posts_speciallist_combat1(inputs)
	if (locale === "pt") return pt_misc_posts_speciallist_combat1(inputs)
	if (locale === "ro") return ro_misc_posts_speciallist_combat1(inputs)
	if (locale === "fi") return fi_misc_posts_speciallist_combat1(inputs)
	if (locale === "sv") return sv_misc_posts_speciallist_combat1(inputs)
	if (locale === "vi") return vi_misc_posts_speciallist_combat1(inputs)
	if (locale === "tr") return tr_misc_posts_speciallist_combat1(inputs)
	if (locale === "cs") return cs_misc_posts_speciallist_combat1(inputs)
	if (locale === "bg") return bg_misc_posts_speciallist_combat1(inputs)
	if (locale === "ru") return ru_misc_posts_speciallist_combat1(inputs)
	if (locale === "uk") return uk_misc_posts_speciallist_combat1(inputs)
	if (locale === "ar") return ar_misc_posts_speciallist_combat1(inputs)
	if (locale === "hi") return hi_misc_posts_speciallist_combat1(inputs)
	if (locale === "th") return th_misc_posts_speciallist_combat1(inputs)
	if (locale === "ja") return ja_misc_posts_speciallist_combat1(inputs)
	if (locale === "zh-CN") return zh_cn2_misc_posts_speciallist_combat1(inputs)
	if (locale === "zh-Hant") return zh_hant1_misc_posts_speciallist_combat1(inputs)
	return ko_misc_posts_speciallist_combat1(inputs)
});
export { misc_posts_speciallist_combat1 as "misc.posts.specialList.combat" }